export const serverTime = (time) => {
    return {
        type: 'Time',
        time: time,
    }
}
